import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import DialogContent from "@material-ui/core/DialogContent";
import { RouteComponentProps } from "react-router";
import UiDialogTitle from "../../common/UiDialogTitle";
import withContext from "../../../tools/withContext";
import CheckIcon from "@material-ui/icons/Done";
import RemoveIcon from "@material-ui/icons/Remove";
import InProgressIcon from "@material-ui/icons/MoreHoriz";
import CorrectIcon from "@material-ui/icons/Refresh";
import DoubleCheckIcon from "@material-ui/icons/DoneAll";
import t from "../../../locales/t";

const styles = (theme: Theme) =>
  createStyles({
    form: {
      padding: `${theme.spacing.unit * 1}px ${theme.spacing.unit * 4}px`,
    },
    formArea: {
      overflowY: "hidden",
    },
    list: {
      height: 250,
      overflowY: "scroll",
      minWidth: "345px",
    },
    input: {
      marginBottom: "1em",
      minWidth: "345px",
    },
    action: {
      paddingRight: "48px",
      paddingBottom: "24px",
    },
  });

interface PropsTypes extends RouteComponentProps<any> {
  onSubmit: Function;
  batchState: string;
  open: boolean;
  onClose: any;
  classes: any;
}

export const BATCH_STATUS = {
  NOT_STARTED : { name: "NOT_STARTED", label: "STATUS_NOT_STARTED", color: "black", filter: "NOT_STARTED", icon: RemoveIcon },
  IN_PROGRESS : { name: "IN_PROGRESS", label: "STATUS_IN_PROGRESS", color: "blue", filter: "IN_PROGRESS", icon: InProgressIcon },
  COMPLETED : { name: "COMPLETED", label: "STATUS_COMPLETED", color: "green", filter: "COMPLETED", icon: CheckIcon },
  TO_BE_CORRECTED : { name: "TO_BE_CORRECTED", label: "STATUS_TO_BE_CORRECTED", color: "orange", filter: "TO_BE_CORRECTED", icon: CorrectIcon },
  VERIFIED : { name: "VERIFIED", label: "STATUS_VERIFIED", color: "green", filter: "VERIFIED", icon: DoubleCheckIcon },
}

const FilteringBatchesDialog = (props: PropsTypes) => {
  const { open, onClose, classes, batchState, onSubmit } = props;

  const [batchStatus, setBatchStatus] = useState<any>("null");

  const handleChange = (e: any) => {
    setBatchStatus(e.target.value);
    onSubmit(e.target.value !== "null" ? e.target.value : null);
    onClose();
  };

  React.useEffect(() => {
    setBatchStatus(batchState || "null")
  }, [batchState])

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="list-actif-title">
      <form className={classes.formArea}>
        <UiDialogTitle title="Filtrer par statut" onCloseClick={onClose} />
        <DialogContent>
          <FormControl className={classes.formControl}>
            <RadioGroup
              aria-label="Status"
              name="status"
              className={classes.group}
              value={batchStatus}
              onChange={handleChange}
            >
              <FormControlLabel
                value="null"
                control={<Radio />}
                label={"Aucun filtre"}
              />
              {Object.keys(BATCH_STATUS).map((key) => {
                return (
                  <FormControlLabel
                    value={
                      //@ts-ignore 
                      BATCH_STATUS[key].filter
                    }
                    control={<Radio />}
                    label={
                      //@ts-ignore 
                      t(BATCH_STATUS[key].label)
                    }
                  />
                )
              })}
            </RadioGroup>
          </FormControl>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default withStyles(styles)(
  withRouter(withContext(FilteringBatchesDialog))
);
